import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import { LanguageProvider } from './contexts/LanguageContext';
import { analytics } from './utils/firebase';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Cart from './pages/Cart';
import Orders from './pages/Orders';
import ProductDetail from './pages/ProductDetail';
import MenuOrder from './pages/MenuOrder';
import Products from './pages/Products';
import AdminDashboard from './pages/AdminDashboard';
import AdminProducts from './pages/AdminProducts';
import AdminOrders from './pages/AdminOrders';
import AdminCategories from './pages/AdminCategories';
import AdminMenu from './pages/AdminMenu';
import AdminMenuCategories from './pages/AdminMenuCategories';
import UserManagement from './pages/UserManagement';
import OrderDetail from './pages/OrderDetail';
import Login from './pages/Login';
import './index.css';

function App() {
  useEffect(() => {
    // Firebase Analytics is initialized
    if (analytics) {
      console.log('Firebase Analytics initialized');
    }
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="App">
          <Routes>
            <Route path="/" element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            } />
            <Route path="/menu-order" element={
              <ProtectedRoute>
                <MenuOrder />
              </ProtectedRoute>
            } />
            <Route path="/products" element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            } />
            <Route path="/cart" element={
              <ProtectedRoute>
                <Cart />
              </ProtectedRoute>
            } />
            <Route path="/orders" element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            } />
            <Route path="/product/:id" element={
              <ProtectedRoute>
                <ProductDetail />
              </ProtectedRoute>
            } />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/products" element={
              <ProtectedRoute requiredRole="admin">
                <AdminProducts />
              </ProtectedRoute>
            } />
            <Route path="/admin/orders" element={
              <ProtectedRoute requiredRole="admin">
                <AdminOrders />
              </ProtectedRoute>
            } />
            <Route path="/admin/categories" element={
              <ProtectedRoute requiredRole="admin">
                <AdminCategories />
              </ProtectedRoute>
            } />
            <Route path="/admin/menu" element={
              <ProtectedRoute requiredRole="admin">
                <AdminMenu />
              </ProtectedRoute>
            } />
            <Route path="/admin/menu-categories" element={
              <ProtectedRoute requiredRole="admin">
                <AdminMenuCategories />
              </ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute requiredRole="admin">
                <UserManagement />
              </ProtectedRoute>
            } />
            <Route path="/admin/order/:id" element={
              <ProtectedRoute requiredRole="admin">
                <OrderDetail />
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
